<h2 mat-dialog-title>Contratos</h2>
<p *ngIf="debtor !== undefined" id="debtor" style="align-items: center; justify-content: center;">
  <small>Cliente: {{ debtor?.name }}</small>
  <small>CPF/CNPJ: {{ debtor?.cpfCnpj }}</small>
</p>
<p class="sub-title">Selecione o contrato que deseja consultar.</p>
<mat-dialog-content
  style="overflow-y: scroll; overflow-x: hidden; height: 15em; white-space:nowrap;"
>
  <mat-list class="mat-list" *ngFor="let contrato of data">
    <mat-list-item
      class="contrato mat-list-item mat-list-item-avatar mat-2-line"
      (click)="selectContract(contrato)"
    >
      <div class="mat-list-item-content">
        <div class="mat-list-item-ripple mat-ripple"></div>
        <!-- <img
          class="avatar"
          onError="this.src='assets/images/escritorios/no-img.png'"
          [src]="contrato.logoImagem"
        /> -->
        <div class="mat-list-text">
          <p class="mat-line">
            Nº {{ contrato.numberContract }} <!-- - {{ contrato.status | uppercase }} -->
          </p>
          <small class="mat-line" style="color:#394554; font-size: 10px;">
            Credor: {{ contrato.collectionPortfolio.companyName }}
          </small>
          <small class="mat-line" style="color:#394554; font-size: 10px;">
            Objeto financiado: {{ contrato.collectionPortfolio.productName }}
          </small>
          <!-- <small class="mat-line" style="color:#394554; font-size: 10px;">
            {{ contrato.name }}/{{ contrato.fantasia }}
          </small> -->
        </div>
      </div>
    </mat-list-item>
  </mat-list>
</mat-dialog-content>
<mat-dialog-actions>

  <span fxFlex></span>
  <button
    type="button"
    mat-raised-button
    color="primary2"
    style="box-shadow: none !important;"
    (click)="dialogRef.close(true)"
  >
    Voltar
  </button>
</mat-dialog-actions>


